import {call, put, takeLatest} from "redux-saga/effects";
import {apiArticles, apiAuthors, apiGetArticleList, apiGetAutorsList, apiGetThemeList, apiKindergartens, apiRegions} from "./api";
import {
    fetchArticlesAction,
    fetchArticlesActionDone,
    fetchArticlesActionFail,
    fetchAuthorsAction,
    fetchAuthorsActionDone,
    fetchAuthorsActionFail,
    fetchRegionsAction,
    fetchRegionsActionDone,
    fetchRegionsActionFail,
    fetchKindergartensAction,
    fetchKindergartensActionDone,
    fetchKindergartensActionFail,
    fetchThemeListDone,
    fetchThemeListFail,
    fetchThemeListAction,
    fetchArticleListDone,
    fetchArticleListFail,
    fetchAutorsListFail,
    fetchAutorsListDone,
    fetchArticleListAction,
    fetchAutorsListAction
} from "./actions";
import {PayloadAction} from "@reduxjs/toolkit";


function* articlesFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiArticles, payload)
    if (data) {
      yield put(fetchArticlesActionDone(data))
    }

  } catch (e) {
    yield put(fetchArticlesActionFail())
  }
}

function* authorsFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiAuthors, payload)
      if (data) {
        yield put(fetchAuthorsActionDone(data))
      }
  
    } catch (e) {
      yield put(fetchAuthorsActionFail())
    }
  }

  function* regionsFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiRegions, payload)
      if (data) {
        yield put(fetchRegionsActionDone(data))
      }
  
    } catch (e) {
      yield put(fetchRegionsActionFail())
    }
  }

  function* kindergartensFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiKindergartens, payload)
      if (data) {
        yield put(fetchKindergartensActionDone(data))
      }
  
    } catch (e) {
      yield put(fetchKindergartensActionFail())
    }
  }

  function* themeListFlow({payload}:PayloadAction<any>): any {
    try {
      const response = yield call(apiGetThemeList, payload);
      yield put(fetchThemeListDone(response));
    } catch (e) {
      yield put(fetchThemeListFail({}));
    }
  }

  function* articleListFlow({ payload }: PayloadAction<any>): any {
    try {
      const response = yield call(apiGetArticleList, {
        header: payload.header,
        author_id: payload.authorId,
        theme_id: payload.themeId,
        page: payload.page,
        category_id: payload.categoryId,
      });
      yield put(fetchArticleListDone(response));
    } catch (e) {
      yield put(fetchArticleListFail({}));
    }
  }
  
  function* autorsListFlow({ payload }: PayloadAction<any>): any {
    try {
      const response = yield call(apiGetAutorsList, {
        fio: payload.fio,
        theme_id: payload.themeId,
      });
      yield put(fetchAutorsListDone(response));
    } catch (e) {
      yield put(fetchAutorsListFail({}));
    }
  }

export default function* screeningSaga() {
  yield takeLatest(fetchArticlesAction,articlesFlow);
  yield takeLatest(fetchAuthorsAction,authorsFlow);
  yield takeLatest(fetchRegionsAction,regionsFlow);
  yield takeLatest(fetchKindergartensAction,kindergartensFlow);
  yield takeLatest(fetchThemeListAction, themeListFlow);
  yield takeLatest(fetchArticleListAction, articleListFlow);
  yield takeLatest(fetchAutorsListAction, autorsListFlow);
}